/*
 * Purpose : Tool sales view page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { useState, useEffect, useContext } from "react";
import ReactTable from "react-table";
import {NavLink, useParams, useHistory} from 'react-router-dom';
import moment from 'moment';
//import _ from "lodash";
import numeral from 'numeral';
import {
  Button,
  Alert,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  CardTitle
} from "reactstrap";
import { MdCancel } from 'react-icons/md';
//import { MdEdit, MdVisibility, MdDelete } from "react-icons/md";
import {FaDownload} from "react-icons/fa"
//import {FaPlusCircle} from "react-icons/fa"
import {FiEdit} from "react-icons/fi"
import {AiOutlineFilePdf} from "react-icons/ai"
//import { Col, FormGroup, Label, Input, Row, Form, FormFeedback } from "reactstrap";
import { Col, FormGroup, Input, Row, Form} from "reactstrap";
import {FaCheckCircle} from "react-icons/fa";
//import { API, graphqlOperation, Storage } from "aws-amplify";
import { Storage } from "aws-amplify";

import "./ToolSalesView.css";

import { toolDeclarationTableHeaders, toolSalesViewTxnHeaders, approvalStages, userRoles, generalConstants } from "../../../config/constants";
import LoadingModal from "../../../components/UI/modals/loadingModal";
import BackButton from '../../UI/Buttons/BackButton/BackButton';
import {ToolSalesFormService} from '../../../services/ToolSalesFormService';
import ViewItem from "../../UI/CustInput/ViewItem/ViewItem";
import { colors } from "../../../styleConstants";
import AppContext from "../../../context/app-context"
import L1L2Approval from "../Approvals/L1L2Approval";
import ApprovalButton from "../Approvals/ApprovalButton";
import {PDFService} from "../../../services/PDFService"
import CancelAlertModal from "../../UI/modals/CancelAlertModal";

const formService = new ToolSalesFormService();

// initial values for the form
const initialHeaderValues = {
  transactiontype: "Tool Sales",
  date: moment().format("YYYY-MM-DD"),
  broker:"",
  buyer:"",
  l3_fab_approver:"",
  l3_fin_approver:"",
  total_price:"",                                    
  rejectedreason:"",
  comment:"",
}

const ToolSalesView = (props) => {
  
  const [loading, setLoading] = useState(false);
  const [headerData, setHeaderData] = useState(initialHeaderValues);
  const [declaredToolData, setDeclaredToolData] = useState([]);
  const [nonDeclaredToolData, setNonDeclaredToolData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [modal, setModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmError, setConfirmError] = useState(null)
  const[toolList, setToolList] = useState([])
  const[fileData, setFileData] = useState({})
  const [cancelModal, setCancelModal] = useState(false)

  let pathParams = useParams(); // will get path params if any
  let history = useHistory(); 

  // to get the user details from context api
  let appContext = useContext(AppContext);

  const toggleModal = () => setModal(!modal);

  // to get the values of the transaction to display
  const getInitialFormData = async () => {   
    

    //console.log('pathParams transid==>',pathParams.transid)
    
      try {
        const transactionDetailForEdit = await formService.getTransactionDetailForEdit(pathParams.transid)
        
        const txnResults = transactionDetailForEdit.data.listExcesstoolsalestransactionss.items[0];
        delete txnResults.date
        //console.log('txnResults==>',txnResults)
        setHeaderData({
          ...headerData,
          ...txnResults
        })

        const txnFileResults = transactionDetailForEdit.data.listExcesstoolsalesfilesdatas.items[0];
        //console.log('txnFileResults==>',txnFileResults)      
        
        // s3 get
        if(txnFileResults){
            const result = await Storage.get(txnFileResults.name, { download: true });
            //console.log("s3 get result==>",result)
            const url = URL.createObjectURL(result.Body);
            //console.log(url)
            txnFileResults.url = url
            txnFileResults.file = result.Body

            setFileData({...fileData, ...txnFileResults})
        }
                   
      } catch (error) {
        console.log("error=>",error)
        setLoading(false)
        setConfirmError("There is a technical error. Please try again..!")
        return false
      }

      // linked tool list 
      try {
        const linkedToolResult = await formService.getLinkedToolList(pathParams.transid)
        const data = linkedToolResult.map((e) => {
          const rec = { ...e };
          //rec.actions = buildActions(e);
          return rec;
        });
        //console.log("data fetched",data);  
        setDeclaredToolData(data.filter( obj => obj.declared_type==="Yes"));      
        setNonDeclaredToolData(data.filter( obj => obj.declared_type==="No"));
      } catch (error) {
        console.log("error=>",error)
        setLoading(false)
        setConfirmError("There is a technical error. Please try again..!")
        return false
      }
    
  };

  const submitApproval = async (toolList, priceData, file_data) => {
    setModal(false)
    setLoading(true)
    // console.log("toollist",toolList)
    // console.log("priceData",priceData)
    // console.log("fileData=>",fileData)
    let fileObj = file_data.name ? file_data : fileData
    //console.log('fileObj=>',fileObj)
    // call update function
    const result = await formService.updateDeal(priceData, toolList, appContext.user, "approval",fileObj)
    //console.log("result=>",result)
    if(result){
      setLoading(false)
      setConfirmModal(true)
      //history.push("/toolsales/transactions")
    }else{
      setLoading(false)
      setConfirmError("There is a technical error. Please try again..!")
      return false
    }
    
  }

  // to handle reject request
  const handleReject = async () => {
    //console.log(headerData.rejectedreason)
    if(headerData.rejectedreason){
      setConfirmError(null)
    }else{
      setConfirmError("Please Enter Rejected Reason")
      return false
    }
    setModal(false)
    setRejectModal(false)
    setLoading(true)
    // console.log("toollist",headerData)
    const result = await formService.updateDeal(headerData, toolList, appContext.user, "reject")
    //const result = await formService.updateTransaction(headerData, appContext.user, null, "reject")
    if(result){
      setLoading(false)
      setConfirmModal(true)
    }else{
      setLoading(false)
      setConfirmError("There is a technical error. Please try again..!")
      return false
    }
    // call reject function
  }

  // to call on submit OK
  const resetComponent = () => {
    setConfirmModal(!confirmModal)
    setLoading( prevState => !prevState)
    //window.location.href =`/toolsales/transactions`
    history.push("/toolsales/transactions")    
  }

  const askForCancel = () => {
    setCancelModal(true)
  }
  const cancelAction = async () =>{    
    setLoading(true)
    setCancelModal(false)
    try {
      const result = await formService.updateDeal(headerData, toolList, appContext.user, "cancel")
      if(result){
        setLoading(false)
        setConfirmModal(true)
      }else{
        setLoading(false)
        setConfirmError("There is a technical error. Please try again..!")
        return false
      }
    } catch (error) {
      console.log("error in delete",error)
      setConfirmError("There is a technical error. Please try again..!")
      setLoading(false)
    }
  }  


  useEffect(() => {
    //console.log("useeffect");    
    setLoading(true);
    const buildData = async () => {
      // set Table Headers
      const columns = [];
      Object.keys(toolDeclarationTableHeaders).forEach((col, i) => {
        if( col.toLowerCase() === "actions" ) {
          return true;
        }else if( col === "toolid" ) {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 120,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }else if( col === "location" || col === "vendor" ) {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 130,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }
        else if( col === "capitalized_date" ) {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 130,
            headerClassName: 'header-style',
            className:'column-style-right'
            //headerClassName: 'wordwrap'
          });
        }else if( col === "remarks" || col === "fin_analysis") {
          columns.push({
            //Header: ()=><div style={{fontSize:"smaller"}}>{toolDeclarationTableHeaders[col]}</div>,
            Header:toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 250,            
            //headerClassName: 'wordwrap'
            headerClassName: 'header-style',
            getProps: (state, rowInfo, column) => {
              //console.log("len=>",rowInfo?.row?.comment?.length) 
              // to make the data in the column wrap and size to small
              return {
                  style: {
                      whiteSpace:"unset",
                      fontSize: rowInfo?.row?.[col]?.length > 70 ? "x-small" : "smaller"
                  },
                };
            },

          });
        }
        else if(col === "price"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 110,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
          }
              
          });
        }
        else if(col === "org_eqp_price"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 160,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
          }
              
          });
        }
        else if(col === "nbv"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 100,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
          }
              
          });
        }else if(col === "price_percent"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 215,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
          }
              
          });
        }else if(col === "asset_mgt_status") {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 155,
            //headerClassName: 'wordwrap'
            headerClassName: 'header-style',
            className:'column-style'
          });
        }
        else if(col === "no_internal_reuse"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            //headerClassName: 'wordwrap',
            minWidth: 300,
            headerClassName: 'header-style',
            className:'column-style',
            Cell: e=> {
              if(e.value==="Yes")              
                return <div style={{textAlign:"center"}}><FaCheckCircle color="green"/></div>
              else
                return ""
          }
              
          });
        } 
        else {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }
      });
      setColumns(columns);
      await getInitialFormData();
      // console.log("columns=>",columns)
      //console.log("data=>", data);
      //file url
      // const byteArray = new Uint8Array(file)
      // const blob = new Blob([byteArray], { type: mimeType })
      // const url = window.URL.createObjectURL(blob)

      
      
      setLoading(false);
    };

    buildData();
    
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 50,
  //     behavior: "smooth"
  //   });
  // }, [])


  return (
    <Form>
      <Alert color="danger" isOpen={confirmError != null ? true : false}>
        {confirmError}
      </Alert>
      <CancelAlertModal open={cancelModal} handler={setCancelModal} deleteHandler={()=>cancelAction()}/>
      <div className="topBtnDiv">
        <Row form style={{ justifyContent: "flex-end" }}>
          <Col md="auto">
            <Alert color="info" isOpen={true} style={{fontSize:"12px", textAlign: "left"}}>
              {generalConstants.disclaimer}<br/>{generalConstants.disclaimer2}
            </Alert>
          </Col>
          <Col md="auto">
            <BackButton path="/toolsalesform" label="Go Back To Sales Home"/>
          </Col>
          <Col md="auto">
            <BackButton path="/toolsales/transactions" exact label="Go Back To Transactions"/>
          </Col>
        </Row>
      </div>     

      <LoadingModal open={loading} msg="Loading..." />
      <div className={"form"}>
        <Modal
          isOpen={modal}
          toggle={toggleModal}
          size="xl"
          draggable={false}
          centered={true}
        >
          <ModalHeader>Data Update</ModalHeader>
          <ModalBody>
            <L1L2Approval
              data={[...declaredToolData,...nonDeclaredToolData]}
              headerData={headerData}
              submitHandler = {submitApproval}
              closeHandler={toggleModal}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={rejectModal}
          toggle={() => setRejectModal(!rejectModal)}
          size="lg"
          draggable={false}
          centered={true}
        >
          <ModalHeader >Rejection Reason</ModalHeader>
          <ModalBody>
              <Alert color="danger" isOpen={confirmError != null ? true : false}>
                {confirmError}
              </Alert>
              Please provide reason for rejection
            <Input type="textarea" onBlur={(e)=> setHeaderData( {...headerData, "rejectedreason":e.target?.value?.trim()} )} />
          </ModalBody>
          <ModalFooter>
            <Button color="danger" value="REJECTED" onClick={()=>handleReject()}>Reject</Button>
            <Button color="secondary" value="Cancel" onClick={()=>setRejectModal(prev=>!prev)}>Cancel</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={confirmModal}>
          <ModalHeader>Success!</ModalHeader>
          <ModalBody>Request has been processed successfully</ModalBody>
          <ModalFooter>
            {/* <NavLink
              style={{ textDecoration: "none" }}
              to="/toolsales/transactions"
              exact
            > */}
              <Button color="primary" onClick={resetComponent} >OK</Button>{" "}
            {/* </NavLink> */}
          </ModalFooter>
        </Modal>

        <div className="mainTSF">
          <div className="headerTSV">
            <h5>Transaction Details</h5>
          </div>
          <br></br>
          <br></br>
          <div style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }} >
            <Row>
                <Col>
                    <CardTitle tag="h6" style={{color:"#17a2b8"}}>{toolSalesViewTxnHeaders.deal_ref}: {headerData.deal_ref}&nbsp;&nbsp;&nbsp;&nbsp;
                    
                    {
                      ((headerData.status === approvalStages.draft || (headerData.status?.indexOf("Rejected") !== -1 && headerData.status?.indexOf("Pending") === -1 && headerData.status !== approvalStages.cancelled) || headerData.status === approvalStages.approved) && (appContext.role === "Admin" || appContext.role === userRoles["Tool Sales Creator"] || appContext.user === headerData.initiator)) &&
                      <NavLink to={`/toolsales/editform/${headerData.transactionid}`} style={{textDecoration: 'none', color:"#fb8734"}}>
                          <FiEdit  style={{ fontSize: "20px"}}/>&nbsp;<span className="actionTag">Edit Transaction</span>
                      </NavLink>                      
                    }
                    &nbsp;&nbsp;&nbsp;
                    <span style={{cursor: "pointer"}} onClick={()=>PDFService(headerData,declaredToolData,nonDeclaredToolData,fileData)}> 
                      <AiOutlineFilePdf  style={{ fontSize: "20px", color:colors.infoColor}}/>&nbsp;<span className="actionTag">Export As PDF</span>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    {
                      ((headerData.status?.indexOf("Cancelled") === -1) && (appContext.role === "Admin" || appContext.role === userRoles["Tool Sales Creator"] || appContext.user === headerData.initiator)) &&
                      <span style={{cursor: "pointer"}} onClick={() => askForCancel()}> 
                        <MdCancel  style={{ fontSize: "20px", color:colors.cancelColor}}/>&nbsp;<span style={{color:colors.cancelColor}} className="actionTag">Cancel Deal</span>
                      </span>
                    }
                    {/* {
                      <NavLink to={`/toolsales/editformAAA/${headerData.transactionid}`} style={{textDecoration: 'none', color:colors.cancelColor}}>
                          <MdCancel  style={{ fontSize: "20px"}}/>&nbsp;<span className="actionTag" onClick={() => askForCancel()} >Cancel Deal</span>
                      </NavLink>                      
                    } */}
                    </CardTitle>
                </Col>
            </Row>
            <Row form style={{ justifyContent: "space-evenly" ,marginTop:"3%" }}>
                <Col md="12">
                    <FormGroup>
                        <Row form style={{ justifyContent: "felx-start" }}>
                            {Object.keys(toolSalesViewTxnHeaders).map( key => 
                                {
                                  if(key !=="deal_ref"){
                                    if(key ==="date"){
                                      return <ViewItem tag={toolSalesViewTxnHeaders[key]} value={ moment(headerData[key]).format("D MMM YYYY") } width="3"/>  
                                    }
                                    else if(key ==="total_price" || key === "total_nbv"){
                                      return <ViewItem tag={toolSalesViewTxnHeaders[key]} value={ numeral(headerData[key]).format('0,0.00') } width="3"/>  
                                    }else if(key ==="total_gain_loss"){
                                      let value = numeral(headerData[key]).value()<0 
                                                  ? <span style={{color:colors.dangerColor}}>{numeral(headerData[key]).format('0,0.00')}</span>
                                                  : numeral(headerData[key]).value()>0  
                                                  ? <span style={{"color":colors.successColor}}>{numeral(headerData[key]).format('0,0.00')}</span>
                                                  : <span style={{"color":colors.draftColor}}>{numeral(headerData[key]).format('0,0.00')}</span>
                                      return <ViewItem tag={toolSalesViewTxnHeaders[key]} value={ value } width="3"/>  
                                    }
                                    else if(key ==="status"){
                                      let value = (headerData[key]?.trim().toLowerCase().indexOf("pending")!==-1)
                                                  ? <span style={{"color":colors.warningColor}}>{headerData[key]?.trim()}</span>
                                                  : (headerData[key]?.trim().toLowerCase().indexOf("rejected")!==-1)
                                                  ? <span style={{"color":colors.dangerColor}}>{headerData[key]?.trim()}</span>
                                                  : (headerData[key]?.trim().toLowerCase().indexOf("cancelled")!==-1)
                                                  ? <span style={{"color":colors.cancelColor}}>{headerData[key]?.trim()}</span>
                                                  : (headerData[key]?.trim().toLowerCase()==="draft")
                                                  ? <span style={{"color":colors.draftColor}}>{headerData[key]?.trim()}</span>
                                                  : <span style={{"color":colors.successColor}}>{headerData[key]?.trim()}</span>
                                      return <ViewItem tag={toolSalesViewTxnHeaders[key]} value={ value } width="3"/>  
                                    }else{
                                      return <ViewItem tag={toolSalesViewTxnHeaders[key]} value={headerData[key]} width="3"/>
                                    }
                                  }else{
                                    return true;
                                  }
                                }
                                
                            )}                                                                                                        
                        </Row>                                        
                    </FormGroup>
                </Col>
            </Row>
          </div>
        </div>

        <div className="mainTSF">
          <div className="headerTSV">
            <h5>Tool Details</h5>
          </div>
          <br></br>
          <br></br>

          <div
            style={{
              textAlign: "left",
              marginBottom: "2%",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <div>
              <h6 style={{color:colors.headerColColor}}>
                Declared Tools
              </h6>
              <hr />
            </div>
            
          </div>
          {declaredToolData.length !== 0 ? (
            <div
              style={{
                margin: "0% 2%",
                width: "-webkit-fill-available !important",
              }}
            >
              <ReactTable
                data={declaredToolData}
                columns={columns}
                defaultPageSize={declaredToolData.length}
                className="-striped -highlight"
                showPagination={false}
              />
            </div>
          ) : (
            <div className={"noDataDiv"}>
              <p>No data Found.!</p>
            </div>
          )}
          <br></br>
          <br></br>

          <div
            style={{
              textAlign: "left",
              marginBottom: "2%",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <div>
              <h6 style={{color:colors.headerColColor}}>Non Declared Tools</h6>
              <hr />
            </div>
          </div>
          {nonDeclaredToolData.length !== 0 ? (
            <div
              style={{
                margin: "0% 2%",
                width: "-webkit-fill-available !important",
              }}
            >
              <ReactTable
                data={nonDeclaredToolData}
                columns={columns}
                defaultPageSize={nonDeclaredToolData.length}
                className="-striped -highlight"
                showPagination={false}
              />
            </div>
          ) : (
            <div className={"noDataDiv"}>
              <p>No data Found.!</p>
            </div>
          )}
        </div>

        <div className="mainTSF">
          <div className="headerTSV">
            <h5>File Upload</h5>
          </div>
          <br></br>
          <br></br>
          <div
            style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}
          >
            <Row form style={{ justifyContent: "space-evenly" }}>
              <Col md="12">
                  <FormGroup>
                      <Row form style={{ justifyContent: "felx-start" }}>
                        {
                          <ViewItem tag="SUTL Checklist" value={fileData.description} width="4"/>
                        } 
                                                 
                        <div
                            className={"img-wrap"}
                            style={{ display: fileData.url ? "inline-block" : "none" , marginLeft:"2%"}}
                          >
                          <a
                            style={{color:colors.infoColor}}
                            key={fileData.name}
                            href={fileData.url}
                            download={fileData.name}
                          > {
                            fileData?.name?.indexOf("-$") !== -1 
                            ? 
                              fileData?.name?.replace(fileData.name?.substr(fileData.name?.indexOf("-$"),10),"") 
                            : 
                              fileData.name                            
                          }{" "}<FaDownload/></a>
                        </div> 
                        <div className={"img-wrap-sales-view"} style={{ display: ( fileData.url && fileData.file?.type?.indexOf("image/")!==-1 ) ? "inline-block" : "none" }} >
                          <img src={fileData.url} alt="problem in loading tool" width="100%" height="100%" />
                        </div>     
                      </Row>                                        
                  </FormGroup>
              </Col>              
            </Row>
          </div>
        </div>
        
        <Alert color="danger" isOpen={confirmError != null ? true : false}>
          {confirmError}
        </Alert>
        {
          (headerData.status?.indexOf("Pending") !== -1)
          && 
          (headerData.status ===  approvalStages.l1Approval) && (appContext.role === userRoles.Admin || appContext.role === userRoles["Tool Sales L1 Data Provider"])
          ? <ApprovalButton text="Update Finance Info" setModal={setModal} setRejectModal={setRejectModal} />
          : (headerData.status ===  approvalStages.l2Approval) && (appContext.role === userRoles.Admin || appContext.role === userRoles["Tool Sales L2 Data Provider"])
          ? <ApprovalButton text="L2 Update" setModal={setModal} setRejectModal={setRejectModal} />
          : null
          // (headerData.status ===  approvalStages.l3Approval) && (appContext.role === userRoles.Admin || appContext.role === userRoles["Tool Sales L3 Approver"])
          // ? <ApprovalButton text="L3 Update" setModal={setModal} setRejectModal={setRejectModal} />
          // : null
        }
      </div>
    </Form>
  );
};

export default ToolSalesView;
